/**
 * AI Dashboard Page
 *
 * Placeholder component — the actual LobeChat iframe is rendered
 * by PersistentLobeChat in MainLayout to keep it mounted across navigation.
 *
 * This component exists only to:
 * 1. Satisfy the router (so /ai is a valid route)
 * 2. Provide a fallback if PersistentLobeChat hasn't mounted yet
 *
 * Mirrors BlogDashboardPage / InboxPage pattern exactly.
 */

export function AiPage() {
  // PersistentLobeChat in MainLayout handles the actual iframe rendering
  return null;
}
